var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LocalizationHelper } from './helpers/localization-helper';
import { AppConsts } from './AppConsts';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
/** Pass untouched request through to the next request handler. */
var HttpErrorInterceptor = /** @class */ (function () {
    function HttpErrorInterceptor(localizationService) {
        this.localizationService = localizationService;
    }
    HttpErrorInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        return next.handle(req).pipe(catchError(function (err) {
            if (err instanceof HttpErrorResponse) {
                var errorResponse = err;
                if (errorResponse.status === 0 || !errorResponse.url) {
                    var errorTip = LocalizationHelper.l(_this.localizationService, AppConsts.localization.defaultLocalizationSourceName, 'UnknowErrorTips', null);
                    abp.message.error(errorTip);
                }
                else if (errorResponse.status === 401) {
                    var error = err.error || {};
                    error = error.error || {};
                    if (error.message === 'Current user did not login to the application!') {
                        window.location.href = abp.appPath;
                    }
                }
            }
            return Observable.throw(err);
        }));
    };
    HttpErrorInterceptor = __decorate([
        Injectable()
    ], HttpErrorInterceptor);
    return HttpErrorInterceptor;
}());
export { HttpErrorInterceptor };
